import { useState } from 'react';

export default function UserVoice() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const voices = [
    {
      id: 1,
      image: 'https://ufbdual.com/wp-content/uploads/2022/06/dentist-chair-and-dentist-tools-2021-09-02-01-26-13-utc-scaled.jpg',
      title: '水垢などが原因の目詰まりが無くなった',
      category: '歯科医院・60代',
      description: 'エアータービンやモーターなどの注水経路、スリーウェイシリンジの水経路が非常に細く小さく、水垢などによって詰まってしまう事が多く、特に治療中に水が出なくなると大変な支障を来たすことになるため、それらのトラブルが解消されました。',
    },
    {
      id: 2,
      image: 'https://ufbdual.com/wp-content/uploads/2021/07/filling-a-bathtub-with-water-2021-08-26-15-27-20-utc-scaled.jpg',
      title: 'お風呂の見えなかった汚れがキレイになった',
      category: '60代・夫婦',
      description: '築30年ほどの自宅のリフォーム時にUFB DUALの導入をしました。お家の水まわりはいつも使うものなので、いいものにしたいと思い導入を決めました。ウルトラファインバブルは水回りの清浄化に効果があり、とても満足しています。',
    },
    {
      id: 3,
      image: 'https://ufbdual.com/wp-content/uploads/2022/06/golden-kitchen-faucet-interior-design-2021-09-04-13-07-48-utc-scaled.jpg',
      title: '目に見えない水道管からお家をキレイに',
      category: '50代・男性',
      description: '家族4人で自宅（築10年）に導入をしました。水にはもともと興味関心が高く、ウルトラファインバブルに興味を持ちました。初めは目に見えないものなので半信半疑ではありましたが、使い続けることで効果を実感しています。',
    },
    {
      id: 4,
      image: 'https://ufbdual.com/wp-content/uploads/2020/10/work01_01.jpg',
      title: 'キッチンシンクの取れない汚れが落ちた',
      category: '30代・主婦',
      description: '結婚4年目、夫と戸建てで2人暮らし。古いシャワーヘッドを交換しようと家電量販店に出かけると、ふいに「ウルトラファインバブル」という文字が目に飛びこんできた。導入後、キッチンの汚れが驚くほど落ちやすくなりました。',
    },
    {
      id: 5,
      image: 'https://ufbdual.com/wp-content/uploads/2020/10/work02_01.jpg',
      title: '髪の毛に更なる美を求めて',
      category: '50代・美容師',
      description: '美は、健康から始まると思う。健康とは身体のことだけじゃない。髪の健康だ。あらゆる施術や、薬剤を試してきた。しかし、本当にこだわるべきは「水」なのではないか、と考え始めました。',
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % voices.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + voices.length) % voices.length);
  };

  return (
    <section id="voice" className="py-24 bg-gradient-to-b from-white to-blue-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-40 right-20 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="text-blue-500 font-semibold text-sm uppercase tracking-wider mb-2">USER VOICE</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">導入事例</h2>
        </div>

        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {voices.map((voice) => (
                <div key={voice.id} className="w-full flex-shrink-0 px-4">
                  <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-0">
                      <div className="relative h-80 md:h-auto">
                        <img
                          src={voice.image}
                          alt={voice.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="p-8 flex flex-col justify-center">
                        <div className="inline-block bg-blue-100 text-blue-600 text-xs font-semibold px-3 py-1 rounded-full mb-4 self-start">
                          {voice.category}
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">{voice.title}</h3>
                        <p className="text-gray-600 leading-relaxed">{voice.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-blue-500 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-blue-500 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {voices.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  currentSlide === index ? 'bg-blue-500 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-block bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            導入事例一覧
          </a>
        </div>
      </div>
    </section>
  );
}
